import { createDynamicSlice } from ".";
import { getVendorById, updatePortalPasswordThunk, updatePortalUserThunk } from "../thunks/myProfileThunk";

const updatePortalUserSlice = createDynamicSlice({
  name: "updatePortalUserSlice",
  thunk: updatePortalUserThunk,
  resetActionName: "resetUpdateVendor"
});

const updatePortalPasswordSlice = createDynamicSlice({
  name: "updatePortalPasswordSlice",
  thunk: updatePortalPasswordThunk,
   resetActionName: "resetUpdatePortalPassword"
});

const getVendorByIdSlice = createDynamicSlice({
  name: "getVendorByIdSlice",
  thunk: getVendorById,
  resetActionName: "resetVendorById"
})


export const updatePortalUserReducer = updatePortalUserSlice.reducer;
export const updatePortalPasswordReducer = updatePortalPasswordSlice.reducer;
export const getVendorByIdReducer = getVendorByIdSlice.reducer;
export const {resetVendorById} = getVendorByIdSlice.actions;
export const {resetUpdateVendor} = updatePortalUserSlice.actions;
export const {resetUpdatePortalPassword} = updatePortalPasswordSlice.actions;
